<template>
  <svg
    width="141"
    height="16"
    viewBox="0 0 141 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M38.4 8.38006C38.4 6.55149 37.5619 5.78958 35.5047 5.78958C33.5238 5.78958 32.5333 6.62768 32.5333 8.38006C32.5333 10.1324 33.5238 10.9705 35.5047 10.9705C37.5619 10.9705 38.4 10.1324 38.4 8.38006ZM40.6857 8.38006C40.6857 11.2753 39.0857 13.0277 36.1142 13.0277C34.5904 13.0277 33.219 12.1896 32.5333 10.6658V15.9991H30.1714V3.88482H32.5333V6.09434C33.219 4.57054 34.5904 3.65625 36.1904 3.65625C39.1619 3.65625 40.6857 5.48482 40.6857 8.38006Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M50.5904 8.38199C50.5904 6.62961 49.5999 5.79152 47.619 5.79152C45.5618 5.79152 44.7237 6.55342 44.7237 8.38199C44.7237 10.1344 45.5618 10.9725 47.619 10.9725C49.5999 10.9725 50.5904 10.1344 50.5904 8.38199ZM50.5142 3.88676H52.8761V12.8772H50.5142V10.6677C49.8285 12.1915 48.5332 13.1058 46.9332 13.1058C43.9618 13.1058 42.3618 11.2772 42.3618 8.45818C42.3618 5.56295 43.8856 3.73438 46.7809 3.73438C48.3809 3.73438 49.8285 4.64866 50.438 6.17247V3.88676H50.5142Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M62.019 5.94453H58.9713V10.8207H61.7904V12.8779H59.4285C57.7523 12.8779 56.6094 11.735 56.6094 10.0588V5.94453H54.3999V3.88739H56.6094V1.14453H58.9713V3.8112H62.019V5.94453Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M71.3902 8.91339L73.6759 9.44672C73.1426 11.8086 71.3902 13.0277 68.5711 13.0277C66.895 13.0277 65.5997 12.5705 64.6092 11.7324C63.6188 10.8943 63.1616 9.75149 63.1616 8.38006C63.1616 6.93244 63.6188 5.78958 64.6092 4.95149C65.5997 4.11339 66.895 3.65625 68.5711 3.65625C71.3902 3.65625 73.1426 4.8753 73.6759 7.2372L71.3902 7.77053C71.0854 6.32292 70.3235 5.78958 68.495 5.78958C66.2854 5.78958 65.4473 6.62768 65.4473 8.38006C65.4473 10.1324 66.2854 10.9705 68.495 10.9705C70.3235 10.9705 71.0854 10.4372 71.3902 8.91339Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M85.1808 7.69524V12.8762H82.8189V8.15238C82.8189 6.47619 82.1332 5.79048 80.6856 5.79048C78.9332 5.79048 78.0189 6.70476 78.0189 8.53333V12.8H75.657V0H78.0189V5.94286C78.5522 4.41905 79.6951 3.65714 81.5236 3.65714C83.9617 3.65714 85.1808 5.02857 85.1808 7.69524Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M86.9333 10.3629L89.2191 9.75342C89.4476 10.8963 90.1333 11.2772 91.581 11.2772C92.8 11.2772 93.4857 10.9725 93.4857 10.3629C93.4857 9.75342 93.1048 9.52485 91.8857 9.37247L90.0572 9.1439C88.3048 8.91533 87.2381 7.92485 87.2381 6.47723C87.2381 4.80104 88.7619 3.73438 91.2762 3.73438C93.7905 3.73438 95.2381 4.72485 95.6191 6.40104L93.3333 6.93438C93.181 5.79152 92.5714 5.48676 91.3524 5.48676C90.2095 5.48676 89.6 5.79152 89.6 6.40104C89.6 6.93438 89.981 7.23914 90.8953 7.31533L93.1048 7.62009C94.781 7.84866 95.8476 8.76295 95.8476 10.2106C95.8476 12.0391 94.2476 13.182 91.5048 13.182C88.9143 13.0296 87.2381 11.9629 86.9333 10.3629Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M104.152 5.94453H101.105V10.8207H103.924V12.8779H101.562C99.8856 12.8779 98.7427 11.735 98.7427 10.0588V5.94453H96.5332V3.88739H98.7427V1.14453H101.105V3.8112H104.152V5.94453Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M113.676 8.38199C113.676 6.62961 112.686 5.79152 110.705 5.79152C108.648 5.79152 107.809 6.55342 107.809 8.38199C107.809 10.1344 108.648 10.9725 110.705 10.9725C112.686 10.9725 113.676 10.1344 113.676 8.38199ZM113.6 3.88676H115.962V12.8772H113.6V10.6677C112.914 12.1915 111.619 13.1058 110.019 13.1058C107.048 13.1058 105.448 11.2772 105.448 8.45818C105.448 5.56295 106.971 3.73438 109.867 3.73438C111.467 3.73438 112.914 4.64866 113.524 6.17247V3.88676H113.6Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M126.171 8.91339L128.457 9.44672C127.924 11.8086 126.171 13.0277 123.352 13.0277C121.676 13.0277 120.381 12.5705 119.39 11.7324C118.4 10.8943 117.943 9.75149 117.943 8.38006C117.943 6.93244 118.4 5.78958 119.39 4.95149C120.381 4.11339 121.676 3.65625 123.352 3.65625C126.171 3.65625 127.924 4.8753 128.457 7.2372L126.171 7.77053C125.867 6.32292 125.105 5.78958 123.276 5.78958C121.067 5.78958 120.229 6.62768 120.229 8.38006C120.229 10.1324 121.067 10.9705 123.276 10.9705C125.029 10.9705 125.79 10.4372 126.171 8.91339Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M137.339 12.8762L134.596 8.99048L132.691 10.7429V12.8762H130.405V0H132.691V8.07619L137.034 3.88571H140.005L136.043 7.61905L140.158 12.8762H137.339Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 16.001H5.5619V12.0391H0V16.001Z"
      fill="#AFE614"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.56201 16.001H11.1239V12.0391H5.56201V16.001Z"
      fill="#6EBE00"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.1238 12.0381H22.2476V0H11.1238V12.0381Z"
      fill="#AFE614"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 8H11.1238V0H0V8Z"
      fill="#6EBE00"
    />
  </svg>
</template>
<script setup>
  defineProps({
    color: {
      type: String,
      default: '#FFFFFF'
    }
  });
</script>
